(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-text-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDoc(root) {
    if (root.dataset.hkInit === 'true') return;
    root.dataset.hkInit = 'true';

    var content = root.querySelector('[data-hk-content]');
    if (!content) return;
    var nav = root.querySelector('[data-hk-nav]');
    var toc = root.querySelector('[data-hk-toc]');
    var progress = root.querySelector('[data-hk-progress]');
    var topBtn = root.querySelector('[data-hk-top]');
    var readtime = root.querySelector('[data-hk-readtime]');

    if (readtime) {
      var words = content.innerText.trim().split(/\s+/).length;
      readtime.textContent = Math.max(1, Math.round(words / 200)) + ' min';
    }

    // Wrap tables so they scroll on mobile
    content.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement.classList.contains('hk-doc__table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'hk-doc__table-wrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    var headings = content.querySelectorAll('h2, h3');
    var slugs = {};

    headings.forEach(function (h) {
      if (!h.id) {
        var s = h.textContent.toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-');
        slugs[s] = (slugs[s] || 0) + 1;
        h.id = slugs[s] > 1 ? s + '-' + slugs[s] : s;
      }
      if (h.tagName === 'H2') {
        var anchor = document.createElement('a');
        anchor.className = 'hk-doc__anchor';
        anchor.href = '#' + h.id;
        anchor.setAttribute('aria-label', 'Link to this section');
        anchor.textContent = '#';
        h.appendChild(anchor);
      }
      if (!toc) return;
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'is-sub';
      var link = document.createElement('a');
      link.href = '#' + h.id;
      link.textContent = h.firstChild ? h.firstChild.textContent : h.textContent;
      li.appendChild(link);
      toc.appendChild(li);
    });

    var links = toc ? toc.querySelectorAll('a') : [];

    if (toc && 'IntersectionObserver' in window) {
      var seen = new Map();
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target.id, e.isIntersecting); });
        var activeId = null;
        headings.forEach(function (h) { if (seen.get(h.id) && !activeId) activeId = h.id; });
        if (!activeId) return;
        links.forEach(function (l) {
          l.setAttribute('aria-current', l.getAttribute('href') === '#' + activeId ? 'true' : 'false');
        });
      }, { rootMargin: '-96px 0px -70% 0px' });
      headings.forEach(function (h) { obs.observe(h); });
    }

    function onScroll() {
      if (progress) {
        var rect = content.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.4;
        var done = Math.min(Math.max(-rect.top + window.innerHeight * 0.4, 0), total);
        progress.style.height = (total > 0 ? (done / total) * 100 : 0) + '%';
      }
      if (topBtn) topBtn.classList.toggle('is-visible', window.scrollY > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (nav) {
      var toggle = nav.querySelector('.hk-doc__nav-toggle');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = nav.getAttribute('data-open') === 'true';
          nav.setAttribute('data-open', String(!open));
          toggle.setAttribute('aria-expanded', String(!open));
        });
        nav.addEventListener('click', function (e) {
          if (e.target.tagName === 'A' && window.innerWidth <= 900) {
            nav.setAttribute('data-open', 'false');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hk-doc]').forEach(initDoc);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();
  // Theme editor: re-init when the section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hk-doc]').forEach(initDoc);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-navigation-v2"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.info__section__swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-navigation"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.info__section__swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-review"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('#google__review__gallary', {
    spaceBetween: 30,
    autoplay: { delay: 6500, disableOnInteraction: false },
    breakpoints: { 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 2, spaceBetween: 20 } },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom"]) return;
  try {
    
  // Select elements with class feather-x and add hideIcon class
  document.querySelectorAll('.feather.feather-x').forEach(function (element) {
    element.classList.add('hideIcon');
  });

  // Function to toggle classes and handle body scroll
  function toggleNavbar() {
    document
      .querySelectorAll('.mobile__navbar__showcase, .mobile__navbar__showcase_shadow')
      .forEach(function (element) {
        element.classList.toggle('drawer__show');
      });

    var drawerShow = document.querySelectorAll('.mobile__navbar__showcase.drawer__show').length > 0;

    if (drawerShow) {
      document.body.style.overflow = 'hidden'; // Disable body scroll
    } else {
      document.body.style.overflow = 'auto'; // Enable body scroll
    }

    document.querySelector('.feather.feather-menu').classList.toggle('hideIcon');
    document.querySelector('.feather.feather-x').classList.toggle('hideIcon');
  }

  // Add click event listener to toggler elements
  document.querySelectorAll('.navbar-toggler, .mobile-nav-custom-close').forEach(function (element) {
    element.addEventListener('click', toggleNavbar);
  });

  // Add click event listener to mobile navbar shadow
  document.querySelector('.mobile__navbar__showcase_shadow').addEventListener('click', toggleNavbar);

  // Close the drawer with the Escape key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('.mobile__navbar__showcase.drawer__show')) {
      toggleNavbar();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-with-video-background"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.swiper__brands', {
    loop: true,
    speed: 2000,
    slidesPerView: 6,
    spaceBetween: 10,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      540: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      1300: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  var swiper_lc = new Swiper('.logoCarousel__section__wrapper .swiper__brands', {
    loop: true,
    speed: 2000,
    slidesPerView: 6,
    spaceBetween: 10,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      540: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      1300: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-custom"]) return;
  try {
    
  jQuery(document).ready(function () {
    // script for updating mini cart items
    jQuery('.cart__details__minus__button')
      .off('click')
      .click(async function () {
        let itemId = jQuery(this).closest('.cart__details__large__content').data('product-key');
        let itemQuantity = parseInt(jQuery(this).siblings('.cart__details__current__quantity').text());

        if (itemQuantity > 1) {
          itemQuantity--;
          jQuery(this).siblings('.cart__details__current__quantity').text(itemQuantity);
          
          // Update button state immediately
          if (itemQuantity <= 1) {
            jQuery(this).attr('disabled', 'disabled');
          }
          
          await updateCart(itemId, itemQuantity);
        }
      });

    jQuery('.cart__details__plus__button')
      .off('click')
      .click(async function () {
        let itemId = jQuery(this).closest('.cart__details__large__content').data('product-key');
        let itemQuantity = parseInt(jQuery(this).siblings('.cart__details__current__quantity').text());

        itemQuantity++;
        jQuery(this).siblings('.cart__details__current__quantity').text(itemQuantity);
        
        // Update minus button state immediately (enable it since quantity is now > 1)
        let minusButton = jQuery(this).siblings('.cart__details__minus__button');
        if (minusButton.length && itemQuantity > 1) {
          minusButton.removeAttr('disabled');
        }
        
        await updateCart(itemId, itemQuantity);
      });

    // update cart item quantity with AJAX
    let requestInProgress = false;

    async function updateCart(itemId, itemQuantity) {
      if (requestInProgress) {
        return Promise.reject('Request already in progress');
      }

      requestInProgress = true;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {
              [itemId]: itemQuantity,
            },
          }),
        });

        if (!response.ok) {
          throw new Error('Cart update failed: ' + response.statusText);
        }

        const cart = await response.json();

        if (cart) {
          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: {
              cart: cart,
            },
          });
          window.dispatchEvent(cartUpdatedEvent);
          return cart;
        } else {
          throw new Error('Cart update failed: unknown error');
        }
      } catch (error) {
        console.error('Cart update failed:', error);
        throw error;
      } finally {
        requestInProgress = false;
      }
    }

    jQuery('.cart__details__large__remove__btn')
      .off('click')
      .click(async function () {
        let itemId = jQuery(this).closest('[data-item-id]').data('item-id');
        await removeItemFromCart(itemId);
        jQuery(this).closest('[data-item-id]').remove(); // remove cart item content from DOM
      });

    // remove cart item with AJAX
    async function removeItemFromCart(itemId) {
      let data = {};
      data[itemId] = 0;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: data,
          }),
        });

        if (!response.ok) {
          throw new Error('Cart update failed: ' + response.statusText);
        }

        const cart = await response.json();

        if (cart) {
          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: {
              cart: cart,
            },
          });
          window.dispatchEvent(cartUpdatedEvent);
          validateCheckoutRequirements();
          return cart;
        } else {
          throw new Error('Cart update failed: unknown error');
        }
      } catch (error) {
        console.error('Cart update failed:', error);
        throw error;
      }
    }

    window.addEventListener('cart:updated', function (event) {
      const data = event.detail;
      if ('{{membershipPricingAvailable}}' === 'true') {
        window.location.reload();
      }

      let cartSubtotalPrice = data.cart.items_subtotal_price / 100;
      let cartFormattedPrice = '$' + cartSubtotalPrice.toFixed(2);
      document.querySelector('.cart__details__large__footer__price').textContent = cartFormattedPrice;

      if (data.cart && data.cart.items) {
        data.cart.items.forEach((itemInfo) => {
          let ajaxUpdatePrice = document.querySelector('[data-ajax-update-price="' + itemInfo.key + '"]');
          let ajaxUpdateQuantity = document.querySelector('[data-ajax-update-quantity="' + itemInfo.key + '"]');
          if (ajaxUpdatePrice && ajaxUpdateQuantity) {
            let itemPrice = itemInfo.final_line_price / 100; // divide by 100 to convert to dollars
            let formattedItemPrice = '$' + itemPrice.toFixed(0);
            ajaxUpdatePrice.textContent = formattedItemPrice;
            ajaxUpdateQuantity.textContent = itemInfo.quantity;
            
            // Find the minus button for this item and update its disabled state
            let cartContent = ajaxUpdateQuantity.closest('.cart__details__large__content');
            if (cartContent) {
              let minusButton = cartContent.querySelector('.cart__details__minus__button');
              if (minusButton) {
                if (itemInfo.quantity <= 1) {
                  minusButton.setAttribute('disabled', 'disabled');
                } else {
                  minusButton.removeAttribute('disabled');
                }
              }
            }
          }
        });
      } else {
        console.log('Cart items not found in data:', data);
      }

      // Display logic for content and empty cart
      const cartDetailsWrapper = document.querySelector('.cart__details__wrapper');
      const cartEmptyWrapper = document.querySelector('.cart__empty__wrapper');
      const cartUpsellWrapper = document.querySelector('.cart__upsell__wrapper');

      if (data.cart.item_count === 0) {
        if (cartDetailsWrapper) {
          cartDetailsWrapper.style.display = 'none';
        }
        if (cartEmptyWrapper) {
          cartEmptyWrapper.style.display = 'block';
        }
        if (cartUpsellWrapper) {
          cartUpsellWrapper.style.display = 'none';
        }
      }
    });

 

    // Self-Executing Anonymous Function
    (function () {
      console.log('prefix js is running');
      const endpoint = '/cart.js';
      jQuery.ajax({
        url: endpoint,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
          if (data.item_count === 0) {
            console.log('The cart is empty.');
            jQuery('.cart__details__wrapper').css('display', 'none');
            if (jQuery('.cart__upsell__wrapper')[0]) {
              jQuery('.cart__upsell__wrapper').css('display', 'none');
            }
          } else {
            jQuery('.cart__empty__wrapper').css('display', 'none');
            if (jQuery('.cart__upsell__wrapper')[0]) {
              jQuery('.cart__upsell__wrapper').css('display', 'block');
            }
          }
        },
        error: function (xhr, status, error) {
          console.error('Error:', error);
        },
      });
    })();
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seven-days-products"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('#seven__days__products__swiper', {
    slidesPerView: 8,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
